export function tryParseUrl(url: string): URL | null {
  try {
    return new URL(url.trim())
  }
  catch {
    return null
  }
}

export function isUrl(url: string) {
  return tryParseUrl(url) !== null
}

export function isAbsoluteHttpUrl(url: string) {
  const parsed = tryParseUrl(url)
  return parsed !== null && (parsed.protocol === 'http:' || parsed.protocol === 'https:') && parsed.host.length > 0
}
